import { useNavigate, useParams } from 'react-router-dom'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ApprovalsInformationBlock from 'modules/approvals/components/ApprovalsInformationBlock'
import { RequisitionStatusTag } from 'modules/ats/components/RequisitionStatusTag'
import { useRequisition } from 'modules/ats/hooks/requisitions/useRequisition'

import { RequestActions } from './RequestActions'

const JobRequisitionDetailPage = () => {
  const params = useParams()
  const requisitionId = Number(params.requisition_id)
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { loading, requisition } = useRequisition(requisitionId)
  const data = []

  const {
    access: { id: currentAccessId },
  } = useCurrentSession()

  const showFooterActions = () => {
    if (loading) {
      return false
    }
    const isApprover = requisition.currentApproverIds?.includes(currentAccessId)
    const isAuthorOrApprover = requisition.author.id == currentAccessId || isApprover

    return requisition.status === 'pending' && isAuthorOrApprover
  }

  const onClose = () => {
    navigate(navigation.ats.jobs.requisitions.fullPath())
  }

  if (!!requisition)
    data.push(
      {
        id: 'jobPostingTitle',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.job_opening_title'),
        value: requisition.jobPostingTitle,
      },
      {
        id: 'team',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.team'),
        value: requisition.team?.name,
      },
      {
        id: 'workplace',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.workplace'),
        value: requisition.workplace?.city,
      },
      {
        id: 'reason',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.reason'),
        value:
          requisition.reason === 'new_position'
            ? i18n.t('ats.jobs_requisitions.requisition_detail.reasons.new_position')
            : i18n.t('ats.jobs_requisitions.requisition_detail.reasons.backfill'),
      },
      {
        id: 'hiring_manager',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.hiring_manager'),
        value: requisition.hiringManager?.fullName,
      },
      {
        id: 'process_owner',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.process_owner'),
        value: requisition.recruiter?.fullName,
      },
      {
        id: 'note',
        label: i18n.t('ats.jobs_requisitions.requisition_detail.note'),
        value: requisition.note,
      }
    )

  return (
    <Sidepanel
      title={
        <Box alignItems="center" justifyContent="center" flexDirection="row" flexGrow gap="s12">
          <Text.Normal weight="semibold">
            {i18n.t('ats.jobs_requisitions.requisition_detail.title')}
          </Text.Normal>
          {!!requisition?.status && <RequisitionStatusTag status={requisition.status} />}
        </Box>
      }
      onClose={onClose}
      width="wide"
      closeLabel={i18n.t('ats.jobs_requisitions.requisition_detail.close')}
      footer={showFooterActions() && <RequestActions requisition={requisition} />}
      boxPadding
      open
    >
      <Box height="full">
        {loading ? (
          <Box alignItems="center">
            <Spinner />
          </Box>
        ) : (
          <Box flexGrow gap="s8">
            <Box paddingBottom="s24">
              <ApprovalsInformationBlock
                resourceId={requisition.id}
                resourceType="Ats::Requisition"
              />
            </Box>
            {data.map((item) => (
              <Box gap="s12" flexDirection={item.id === 'note' ? 'column' : 'row'} key={item.id}>
                <Box width="s140">
                  <Text.Normal>{item.label}</Text.Normal>
                </Box>
                <Text.Normal color="grey1000">{item.value}</Text.Normal>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Sidepanel>
  )
}

export default JobRequisitionDetailPage
